import CSSToolTip from 'client/components/common/CSSToolTip/CSSToolTip'
import { l } from 'client/Other/Translation'
import * as React from 'react'

export const EInvoiceCharacterLimitInfo = ({ invalid }) => {
  const invalidClass = invalid ? 'invalid' : ''
  return (
    <div className={'DescriptionLimit'}>
      <span className={invalidClass}>{l('characterLimit.label')}</span>
      <CSSToolTip body={l('characterLimit.body')} header={l('characterLimit.title')} position={'right'} />
    </div>
  )
}

export const EInvoiceCharacterLimitInfoWithCounter = ({ count, invalid }) => {
  const translation = count > 1024 ? l('characterLimit.exceededLabel') : l('characterLimit.countLabel')
  const invalidClass = invalid ? 'invalid' : ''
  return (
    <div className={'DescriptionLimit'}>
      {/* eslint-disable-next-line max-len */}
      <span className={'text ' + invalidClass}>
        {translation} ({count > 1024 ? <p className="bolded contents">{count}</p> : count}/1024)&nbsp;
        <CSSToolTip body={l('characterLimit.body')} header={l('characterLimit.title')} position={'right'} />
      </span>
    </div>
  )
}
